import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useRealtimeEvent } from "../contexts/RealtimeContext";
import { Flame } from "lucide-react";

/**
 * Compact streak indicator for the top header.
 * Hidden when current_streak is 0.
 */
export const StreakBadge = () => {
  const [streak, setStreak] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/couple/streak");
      setStreak(data);
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Refresh on entry status changes (anything that can affect "experienced" set)
  useRealtimeEvent(
    ["entry:created", "entry:updated", "entry:deleted"],
    () => { load(); }
  );

  if (!streak || streak.current_streak < 1) return null;

  const isHot = streak.current_streak >= 3;
  return (
    <div
      className={`hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${
        isHot
          ? "bg-terracotta text-white"
          : "bg-bone text-ink border border-border"
      }`}
      title={`Aktuelle Serie: ${streak.current_streak} Wochen · Längste: ${streak.longest_streak}`}
      data-testid="streak-badge"
    >
      <Flame size={13} strokeWidth={isHot ? 2 : 1.7} />
      <span>{streak.current_streak} {streak.current_streak === 1 ? "Woche" : "Wochen"}</span>
    </div>
  );
};

export default StreakBadge;
